import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { Conversation, Message } from '@repo/shared/src/services/messaging-service/messaging-service.types';

export const setMessageList = createAction('[Message] Set Message List', props<{ messages: Message[] }>());

export const addMessageToList = createAction('[Message] Add Message To List', props<{ message: Message }>());

export const cancelGetMessageList = createAction('[Message] Cancel Get Message List');
export const cancelGetMessageListSuccess = createAction('[Message] Cancel Get Message List Success');

export const getMessageList = createAction(
  '[Message] Get Message List',
  props<{ conversationId: string; isLoadingNeeded: boolean }>(),
);

export const getMessageListSuccess = createAction(
  '[Message] Get Message List Success',
  props<{ messageList: Message[]; conversationId: string }>(),
);

export const getMessageListFailed = createAction(
  '[Message] Get Message List Failed',
  props<{ error: any; conversationId: string; isLoadingNeeded: boolean }>(),
);

export const postMessage = createAction(
  '[Message] Post Message',
  props<{ message: any; conversationId: string; isPostFromDraft: boolean }>(),
);

export const postMessageSuccess = createAction(
  '[Message] Post Message Success',
  props<{ message: Message; conversationId: string; isPostFromDraft: boolean; conversationChanged: boolean }>(),
);

export const postMessageFailed = createAction('[Message] Post Message Failed', props<{ error: any }>());

export const resetMessageError = createAction('[Message] Reset Message Error');

export const patchMessage = createAction(
  '[Message] Patch Message',
  props<{ message: any; messageId: string; conversationId: string; isPatchFromDraft: boolean }>(),
);

export const patchMessageSuccess = createAction(
  '[Message] Patch Message Success',
  props<{ message: Update<Message>; conversationId: string; isPatchFromDraft: boolean }>(),
);

export const deleteMessage = createAction(
  '[Message] Delete Message',
  props<{ messageId: string; conversationId: string; lastMessage: Message }>(),
);

export const deleteMessageSuccess = createAction(
  '[Message] Delete Message Success',
  props<{ messageId: string; updateConversation: Update<Conversation> }>(),
);

export const patchMessageFailed = createAction('[Message] Patch Message Failed', props<{ error: any }>());

export const unsetIdMessagesLoaded = createAction('[Message] Unset idMessagesLoaded');
export const unsetListMessage = createAction('[Message] Unset listMessage');
